import React, { useState, useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import DialogActions from '@material-ui/core/DialogActions'
import SearchIcon from '@material-ui/icons/Search'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import { Paper } from '@material-ui/core'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'

export default function ClientSelector(props) {
    const { clients, selectedClientIds, handleClientSelection, source, isClientMultiSelect } = props

    const [dialogOpen, setDialogOpen] = useState(false)
    const [filteredClients, setFilteredClients] = useState([])
    const [multiSelect, setMultiSelect] = useState(false)

    useEffect(() => {
        if (source === 'shipment' && isClientMultiSelect) {
            setMultiSelect(true)
        }
    }, [source, isClientMultiSelect])

    useEffect(() => {
        const clientsCopy = [...clients]
        clientsCopy.forEach(client => {
            client.checked = selectedClientIds?.includes(client.id)
        })
        setFilteredClients(clientsCopy)
    }, [selectedClientIds])

    const handleClientSelectChange = event => {
        const id = event.target.id
        // need to handle multi select
        if (!multiSelect) {
            const clientsCopy = [...filteredClients]
            clientsCopy.forEach(client => {
                client.checked = client.id === id
            })
            setFilteredClients(clientsCopy)
            return
        }
        const clientsCopy = [...filteredClients]
        const client = clientsCopy.find(client => client.id === id)
        client.checked = !client.checked
        setFilteredClients(clientsCopy)
    }

    const setAllClientsChecked = () => {
        const clientsCopy = [...filteredClients]
        clientsCopy.forEach(client => {
            client.checked = true
        })
        setFilteredClients(clientsCopy)
    }

    const setAllClientsUnchecked = () => {
        const clientsCopy = [...filteredClients]
        clientsCopy.forEach(client => {
            client.checked = false
        })
        setFilteredClients(clientsCopy)
    }

    return (
        <>
            <Button
                variant="outlined"
                startIcon={<SearchIcon />}
                onClick={() => setDialogOpen(true)}
            >
                {
                    selectedClientIds?.length > 0
                        ? clients.find(client => client.id === selectedClientIds[0])?.name + (
                            selectedClientIds?.length > 1
                                ? ` (+${selectedClientIds?.length - 1} more)`
                                : ''
                        )
                        : 'Select Client'
                }
            </Button>
            <Dialog
                open={dialogOpen}
                onClose={() => {
                    setDialogOpen(false)
                    // reset the filtered clients
                    setFilteredClients(clients)
                }}
            >
                <DialogContent>
                    <DialogContentText>
                    {
                        multiSelect &&
                        <>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AddCircleIcon />}
                                onClick={setAllClientsChecked}>
                                Select All
                            </Button>
                            &nbsp;
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<RemoveCircleIcon />}
                                onClick={setAllClientsUnchecked}>
                                Unselect All
                            </Button>
                        </>
                    }
                    </DialogContentText>
                    <div>
                        <br />
                        <TextField
                            style={{ width: '80%' }}
                            onChange={e => {
                                // need to filter the addresses based on the input
                                const value = e.target.value
                                const filteredClients = clients.filter(
                                    client => {
                                        return client.name
                                            .toLowerCase()
                                            .includes(value.toLowerCase())
                                    }
                                )
                                setFilteredClients(filteredClients)
                            }}
                            placeholder={'Enter client name..'}
                            // need to default focus on the text field
                            autoFocus={true}
                        />
                        <br />
                        <br />
                        {filteredClients?.map(client => (
                            <div
                                style={{
                                    height: '35px'
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: '16px',
                                        whiteSpace: 'nowrap',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        handleClientSelectChange({
                                            target: { id: client.id }
                                        })
                                    }}
                                >
                                    {
                                        multiSelect &&
                                        <Checkbox
                                            key={client.id}
                                            id={client.id}
                                            value={client.id}
                                            checked={client.checked}
                                        />
                                    }
                                    <Button
                                        color= {client.checked ? 'primary' : 'default'}
                                        variant= {client.checked ? 'contained' : 'text'}
                                        onClick={
                                            () => {
                                                handleClientSelection([client.id])
                                                setDialogOpen(false)
                                            }
                                        }>
                                        { client.name }
                                    </Button>
                                </span>
                            </div>
                        ))}
                    </div>
                </DialogContent>
                {
                    multiSelect &&
                        <DialogActions>
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<CancelIcon />}
                                onClick={() => {
                                    setDialogOpen(false)
                                }}
                            >
                                Cancel
                            </Button>
                            &nbsp;
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AddCircleIcon />}
                                onClick={async () => {
                                    // get selected clients or client and pass it to the parent function
                                    const checkedClients = filteredClients.filter(
                                        client => client.checked
                                    )
                                    if (!checkedClients.length) {
                                        alert('Please select a client')
                                        return
                                    }
                                    handleClientSelection(
                                        checkedClients.map(client => client.id)
                                    )
                                    setDialogOpen(false)
                                }}
                            >
                                Select
                            </Button>
                        </DialogActions>
                }
            </Dialog>
        </>
    )
}
